<template>
  <div>
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <img src="@/assets/img/family.svg?data" alt="Bild på familj" class="img-fluid" />
          <br />
          <img src="@/assets/img/logo.svg?data" alt="FHabian.nu logotyp" class="img-fluid img-logo-xl" />
          <hr />
          <h1 class="text-primary-fh">Registrera dig</h1>
          <div class="border--emphasize" v-if="!iidQueryParam">
            <p class="font-weight-bold">
              Det verkar som att din inbjudningslänk saknas som du ska ha fått via SMS/E-post.
            </p>
            <p>
              <strong>Exempel på fullständig länk är:</strong>
              <pre>https://ctx.healthsolutions.se?iid=44b0f2d3-4be7-4d94-857a-001eb62a747b</pre>
            </p>
            <p class="font-weight-bold">
              Var vänlig kontrollera att det är via den du har fått åtkomst till denna registreringssida.
            </p>
          </div>
          <div class="border--emphasize" v-if="iidQueryParam">
            <p class="text-center">
              Har du fått en inbjudningslänk så har du kommit rätt. <br />
              Logga in med BankID nedan.
            </p>
            <p class="text-center">
              <strong>
                Notera att denna sida används enbart för registrering. <br />
                Inloggning sker <router-link to="/login"><u>här</u></router-link>.
              </strong>
            </p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix--min"></div>
          <button class="btn btn-primary btn-sm btn-block" @click="loginWithBankId()">
            <img
              src="@/assets/img/bankid.svg?data"
              alt="Logotyp BankID"
              class="logotype"
             />
            Verifiera dig med BankID
          </button>
          <div class="clearfix--min"></div>
          <button class="btn btn-primary btn-sm btn-block" @click="loginWithFreja()">
            <img
              src="@/assets/img/freja.svg?data"
              alt="Logotyp Freja eID"
              class="logotype"
            />
            Verifiera dig med Freja eID
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <div class="clearfix"></div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'register',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      showHelp: false,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  computed: {
    iidQueryParam () {
      const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      return pattern.test(this.$route.query.iid)
    }
  },
  methods: {
    loginWithBankId () {
      let loader = this.$loading.show()
      const callbackUrl = window.location.origin.concat(config.callbackUri)
      localStorage.removeItem('uri')
      sessionStorage.clear()
      axios.postLogin(config.bankIdUri, callbackUrl).then((response) => {
        if (response) {
          loader.hide()
          localStorage.setItem('registerRelative', true)
          localStorage.setItem('reg', JSON.stringify({ ssn: '', invitationLink: this.$route.query.iid }))
          localStorage.setItem('uri', config.tokenBankIdUri)
          window.location.href = response.data.redirectUrl
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    loginWithFreja () {
      let loader = this.$loading.show()
      const callbackUrl = window.location.origin.concat(config.callbackUri)
      localStorage.removeItem('uri')
      sessionStorage.clear()
      axios.postLogin(config.frejaUri, callbackUrl).then((response) => {
        if (response) {
          loader.hide()
          localStorage.setItem('registerRelative', true)
          localStorage.setItem('reg', JSON.stringify({ ssn: '', invitationLink: this.$route.query.iid }))
          localStorage.setItem('uri', config.tokenFrejaUri)
          window.location.href = response.data.redirectUrl
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    }
  },
  async mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:disabled {
  opacity: 0.3;
}
pre {
  font-size: 70%;
  border-top: 1px solid gray;
  padding-top: 0.1em;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.clearfix {
  margin: 30px !important;
}
.container {
  margin-top: 24vh !important;
  min-height: 64vh !important;
}
.logotype {
  height: 55px;
  width: 55px;
}
.border--emphasize {
  border-left: 5px solid #069ccc;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue